<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/route']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'route_common_name' | translate"></nz-statistic>
    </a>
</nz-card>